import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { FORMULA_FIELDS } from './salesData';
export function FormulaSection() {
  return <section id="dentro-de-una-formula" className="bg-white py-11 sm:py-14" data-id="element-86" data-mp="2n4d64padsry0">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-87" data-mp="2n2a75fr93oh5">
        <div className="text-center" data-id="element-88" data-mp="2rw4z16h0f9rb">
          <h2 className="mx-auto max-w-[20ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-89" data-mp="2rx6avd5uo0a3">
            Abrís una fórmula y <span className="text-gold-deep" data-id="element-90" data-mp="30ugmizmkxrfj">sabés qué hacer</span>
          </h2>
          <p className="mx-auto mt-2.5 max-w-[36ch] font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-91" data-mp="35ul6izmp54ai">
            Las 200 fórmulas tienen la misma ficha completa.
          </p>
        </div>

        <motion.ul initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 grid grid-cols-2 gap-1.5 sm:grid-cols-3" data-id="element-92" data-mp="1bhlj4kc2r5so">
          {FORMULA_FIELDS.map(field => <li key={field} className="flex items-start gap-2 rounded-xl bg-cream px-3 py-2.5 font-sans text-[0.78rem] font-semibold leading-tight text-charcoal" data-id="element-93" data-mp="1kfivin2un5sw">
              <CheckIcon className="mt-px h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-94" data-mp="1ahcyojvwgpuw" />
              {field}
            </li>)}
        </motion.ul>
      </div>
    </section>;
}